import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import Dialog from '../../organisms/Dialog';
import LegalCaseForm from './shared/LegalCaseForm';
import useLegalCasePageForm from '../../../hooks/useLegalCasePageForm';

interface LegalCaseListContext {
    refresh: () => void;
}

const LegalCasePageForm = () => {
    const navigate = useNavigate();
    const context = useOutletContext<LegalCaseListContext>();

    const handleClose = () => navigate('/recovery/legal-cases');

    const handleSuccess = () => {
        toast.success('Caso jurídico cadastrado com sucesso');
        context?.refresh();
        handleClose();
    };

    const form = useLegalCasePageForm({ onClose: handleClose, onCreated: handleSuccess });

    return (
        <Dialog
            id="legal-case-form"
            show={true}
            onClose={handleClose}
            header="Novo Caso Jurídico"
            size="lg"
            body={<LegalCaseForm {...form} />}
            footer={
                <div className="flex gap-2">
                    <button onClick={handleClose} disabled={form.isCreating}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 text-sm disabled:opacity-50">
                        Cancelar
                    </button>
                    <button onClick={form.handleCreate} disabled={form.isCreating}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm disabled:opacity-50">
                        {form.isCreating ? 'Salvando...' : 'Cadastrar'}
                    </button>
                </div>
            }
        />
    );
};

export default LegalCasePageForm;
